<template>
    <header
        class="header"
        :class="{fixed: fixed}"
    >
        <div class="content">
            <div class="header-inner">
                <a class="back" href="http://www.ycjs.com.cn/history/index.html" target="_blank"><img src="@/static/images/fanhui.png"/>返回旧版</a>
                <div class="logo-con">
                    <img
                        class="logo header-com"
                        src="/images/logo.png"
                    />
                </div>

                <div class="tel-con">
                    <el-input placeholder="" v-model="searchData">
                        <template slot="append">搜索</template>
                    </el-input>
                </div>
            </div>
        </div>

        <div class="nav-con">
            <div class="content">
                <div class="nav-list">
                    <template v-for="(item, index) in $store.state.config.nav">

                        <a
                            v-if="item.isExternalLink"
                            :href="item.href"
                            :key="item.title"
                            target="_blank"
                            class="nav-item"
                        >{{item.title}}</a>

                        <nuxt-link
                            class="nav-item"
                            :key="index"
                            :to="item.href"
                            :class="{active: isActive(item)}"
                            @click="clickHandler($event, item.click)"
                            v-else
                        >
                            {{item.title}}
                        </nuxt-link>
                    </template>
                </div>
            </div>

        </div>

        <slot></slot>

    </header>
</template>

<script>
import Search from './components/search';

export default {
    components: {
        Search,
    },
    props: {
        theme: {
            type: String,
            default: '',
        },
        fixed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            searchData:''
        };
    },
    computed: {},
    methods: {
        isActive(item) {
            var path = this.$route.path,
                href = item.href,
                activeReg = item.activeReg;

            if (href === path) {
                return true;
            }

            if (path === href) {
                return true;
            }

            // if (activeReg && activeReg.test(path)) {
            //     return true;
            // }

            return false;
        },
        clickHandler(e, cb) {
            if (cb) {
                e.preventDefault();

                var fun = new Function(cb);
                fun.call(this);
            }
        },
    },
    mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@css/var.scss';

.header {
    background: white;
    padding: 11 0px;
    background: url('@/static/images/topbg.jpg');

    &.fixed {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10000;
        min-width: 1200px;
    }

    .header-inner {
        height: 162px;
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .back{
            position: absolute;
            top:10px;
            right:50px;
            font-size: 14px;
            font-weight: bold;
            color:#d1171e ;
            vertical-align: middle;
            cursor: pointer;
            img{
                margin-right:4px;
            }
        }
    }

    .logo-con {
        display: flex;
        align-items: center;

        img.logo {
            width: 500px;
            height: 74px;
        }
    }

    .tel-con {
        font-size: 24px;
        color: #375598;
        font-weight: bold;
        img {
            width: 36px;
            height: 44px;
            vertical-align: middle;
        }
    }

    .nav-con {
        line-height: 61px;
        height: 61px;
        background: #cf312a;

        .nav-list {
            font-size: 18px;
            display: flex;
            justify-content: space-between;

            .nav-item {
                color: #fff;
                text-align: center;
                width:100%;
                // width: 100px;

                &:hover {
                    background: #ef6158 !important;
                }

                &.active {
                    background: #ef6158 !important;
                }
            }
        }
    }

    .search-con {
        display: flex;
        align-items: center;
    }
}

::v-deep .el-input-group--append .el-input__inner{
    border-radius: 30px;
    width: 330px;
    height: 40px;
    line-height: 40px;
    padding-right: 44px;
    border-width: 0px;
}

::v-deep .el-input-group__append, .el-input-group__prepend {
    top: -1px;
    left: -40px;
    border-radius: 30px;
    background: #cf312a;
    font-size: 16px;
    width: 80px;
    line-height: 40px;
    text-align: center;
    color: #fff;
}
</style>
